export const saveToLocalStorage = (key: string, data: string) => {
  localStorage.setItem(key, data);
};

export const generateRowsWithId = <T>(array: T[], keySource: string) => {
  return array.map((item) => {
    return { ...item, id: (item as any)[keySource] };
  });
};

export type Mapping = {
  from: string;
  to: string;
};

export const transformArrayProperties = <T>(
  source: T[],
  mapping: Mapping[]
) => {
  return source.map((item: any) => {
    const obj: any = {};
    mapping.forEach((map) => {
      obj[map.to] = item[map.from];
    });
    return obj;
  });
};

export const sortNumericColumn = (a: number, b: number, order: string) => {
  if (order === "asc") {
    return a - b;
  }
  return b - a;
};

export const getFamilyUnitVersionInConfigurations = (configurations: any) => {
  let unitFamilyId = 47;
  let unitTypeId = 1;
  let unitVersionId = -1;
  const productId =
    configurations &&
    configurations.find(
      (config: { fieldName: string }) => config.fieldName === "unit_family"
    );
  if (productId) {
    unitFamilyId = productId.value ? parseInt(productId.value) : 0;
  }

  const unitType =
    configurations &&
    configurations.find(
      (config: { fieldName: string }) => config.fieldName === "unit_type"
    );
  if (unitType) {
    unitTypeId = unitType.value ? parseInt(unitType.value) : 0;
  }

  const unitVersion =
    configurations &&
    configurations.find(
      (config: { fieldName: string }) => config.fieldName === "unit_version"
    );
  if (unitVersion) {
    unitVersionId = unitVersion.value ? parseInt(unitVersion.value) : 0;
  }

  return { unitFamilyId, unitTypeId, unitVersionId };
};

export const sortAlphabetically = (
  data: any,
  propertyName: string,
  isAscending: boolean = true
) => {
  return data
    ? data.sort((a: any, b: any) => {
        if (isAscending) {
          return a[propertyName].localeCompare(b[propertyName]);
        }

        return b[propertyName].localeCompare(a[propertyName]);
      })
    : [];
};
